import type { ReactNode } from "react";
import AdminSidebar from "@/bizminer/layouts/admin/AdminSidebar.tsx";
import { SidebarInset, SidebarProvider } from "@/components/ui/sidebar.tsx";
import { SimpleThemeToggle } from "@/components/ui/simple-theme-toggle.tsx";
import { useDarkMode } from "@/hooks/use-dark-mode.tsx";

interface AdminLayoutProps {
  children: ReactNode;
}

const AdminPageHeader = () => {
  const { theme, toggle } = useDarkMode();

  return (
    <header className="text-foreground flex h-16 shrink-0 items-center border-b border-border">
      <div className="flex items-center justify-end w-full px-6">
        <SimpleThemeToggle theme={theme} onCycle={toggle} />
      </div>
    </header>
  );
};

export default function BizminerAdminLayout({ children }: AdminLayoutProps) {
  useDarkMode();

  return (
    <SidebarProvider>
      <AdminSidebar variant="inset" />

      <SidebarInset>
        <AdminPageHeader />
        <div className="flex flex-1 flex-col gap-4 p-4 pt-0 w-full fixed:2xl:mx-auto fixed:2xl:max-w-7xl min-w-0">
          <div className="min-h-[100vh] flex-1 rounded-xl md:min-h-min w-full min-w-0 overflow-x-auto">
            <div className="p-4 lg:p-6 w-full text-foreground">{children}</div>
          </div>
        </div>
      </SidebarInset>
    </SidebarProvider>
  );
}
